<template>
  <va-card title="Terms and Conditions">
    <span>
      I recognize that...
    </span>
    <ol class="terms-list">
      <li>
        Rewarding Dog Training, LLC will endeavor to create as safe an environment as possible for the training and care of my dog and will offer only sound, safe, and responsible training, care, and training instructions.  However, I recognize that Rewarding Dog Training, LLC is not responsible for any unintentional errors, omissions, or incorrect assertions.  I understand that the recommendation of any other product or service is not a guarantee of my satisfaction with that product or service.  Further, I am and will remain responsible for the actions of my dog at all times and I hereby agree to indemnify and hold harmless Rewarding Dog Training, LLC of any and all claims of injury, expense, costs, or damages caused by the actions of my dog while under Rewarding Dog Training, LLC care and under my own care as a result of following training instructions.  I have been told by Rewarding Dog Training, LLC and understand the inherent risks in owning a dog, including but not limited to the risk of dog bites to myself or others.
      </li>
      <li>
        Animal behavior is variable and unpredictable. Rewarding Dog Training, LLC makes no express guarantees as to specific behavior change. I will be responsible for continued management and training at home to strengthen and maintain behaviors learned during the training period.
      </li>
      <li>
        Purchases are NON-REFUNDABLE. Private lessons may be rescheduled if both myself and my trainer agree to a change at least 24 hours prior to the appointment start time.
      </li>
      <li>
        Trainers will do their absolute best to respond to phone and e-mail inquiries in a timely manner. Although trainers may occasionally correspond via text to arrange logistical details such as scheduling, longer questions and discussions should be handled by phone, e-mail, or may require an in-person appointment.
      </li>
    </ol>
    <span class="contact-us">
      Please contact us if you have any questions regarding these policies.
    </span>
  </va-card>
</template>

<script>

export default {
  name: 'terms-conditions-card',
}
</script>

<style scoped lang="scss">
  .terms-list {
    list-style: decimal;
    margin-left: 1rem;

    li {
      margin-top: 1rem;
    }
  }

  .contact-us {
    margin-top: 1rem;
  }
</style>
